// ===== rules/rule-0010-local-anaesthetic.ts ================================
import { BaseRule } from '../rule-base';
import { AdjustedLine, ModifierContext } from '../modifier-models';

/**
 * 0010 – local anaesthetic administered by the surgeon.
 * We treat the 0010 line itself as a modifier‐line whose units already contain
 * the "basic anaesthetic units".  Enforce the minimum-7-units rule exactly as
 * modifier 0036 requires.
 */
export class Rule0010LocalAnaes extends BaseRule {
    name = '0010 local-anaesthetic min-7';

    run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void {
        if (line.code !== '0010') return;

        if (line.adjustedUnits < 7) {
            const diff = 7 - line.adjustedUnits;
            if (autoApply) {
                line.adjustedUnits = 7;
                line.trace.push(`0010 min-7 (+${diff})`);
            } else {
                line.suggestions = line.suggestions || [];
                line.suggestions.push({
                    ruleCode: '0010',
                    message: `Minimum 7 units for local anaesthetic (+${diff})`,
                    kind: 'overwrite',
                    unitsDelta: 7
                });
            }
        }
    }

    apply(lines: AdjustedLine[], ctx: ModifierContext): AdjustedLine[] {
        lines
            .filter(l => l.code === '0010')
            .forEach(l => {
                if (l.adjustedUnits < 7) {
                    const diff = 7 - l.adjustedUnits;
                    l.adjustedUnits = 7;
                    l.trace.push(`0010 min-7 (+${diff})`);
                }
            });
        return lines;
    }
}
